import React, { useContext, useMemo } from 'react'
import { getIpadVh } from 'common/ipad'
import { ImageDetailContext } from '../content'
import Info from './info'
import Annotation from '../../imageDetail/infoView/annotation'
import Comment from '../../imageDetail/infoView/comment'
import { HangTab } from '../../imageDetail/infoView'
import styles from './index.module.less'

export enum IMAGE_DETAIL_TAB {
    INFO = 1,
    ANNOTATION = 2,
    COMMENT = 3,
    RECOMMEND = 4
}

export default () => {
  const {
    currentImage,
    tabValue,
    onTabChange,
    onInit,
    notes,
    onIsAnnotate,
    isAnnotate,
    setNotes,
    onChange,
    onActiveNoteIndex,
    commentTotal,
    onInitCommentTotal,
    isMove,
    isShowRight,
    onIsShowRight,
    onBanOperation,
  }:any = useContext(ImageDetailContext)

  const transformStyle = useMemo(() => {
    if (tabValue === IMAGE_DETAIL_TAB.RECOMMEND || isShowRight) {
      return {
        marginRight: '-440px'
      }
    }
    return {
      marginRight: '0px'
    }
  }, [tabValue, isShowRight])

  const TAB_OPTION = [
    { label: '样衣信息', value: IMAGE_DETAIL_TAB.INFO },
    { label: '批注', value: IMAGE_DETAIL_TAB.ANNOTATION },
    { label: '评论', value: IMAGE_DETAIL_TAB.COMMENT, num: commentTotal },
    { label: '相似推荐', value: IMAGE_DETAIL_TAB.RECOMMEND }
  ]

  return <div className={styles.mnImageDetailInfoView} style={{ ...transformStyle, height: getIpadVh() }}>
    <HangTab
      value={tabValue}
      onChange={(val) => onTabChange(val)}
      options={TAB_OPTION}
      isShowRight={isShowRight}
      hasShowRightBtn={tabValue === IMAGE_DETAIL_TAB.ANNOTATION}
      onIsShowRight={(val) => onIsShowRight(val)}
    />
    {tabValue === IMAGE_DETAIL_TAB.INFO && <Info
      currentImage={currentImage}
      onInit={onInit}
      onIsAnnotate={onIsAnnotate}
      onChange={onChange}
      onBanOperation={onBanOperation}
    />}
    {tabValue === IMAGE_DETAIL_TAB.ANNOTATION && <Annotation
      currentImage={currentImage}
      notes={notes}
      setNotes={setNotes}
      setIsAnnotate={onIsAnnotate}
      isAnnotate={isAnnotate}
      isMove={isMove}
      onActiveNoteIndex={onActiveNoteIndex}
      loginUserInfo={currentImage.loginUserInfo}
    />}
    {tabValue === IMAGE_DETAIL_TAB.COMMENT && <Comment
      sampleId={currentImage?.id}
      createUserId={currentImage.createUserId}
      type={1}
      total={commentTotal}
      onInitCommentTotal={onInitCommentTotal}
    />}
  </div>
}
